export const TIMEOUT = 1 * 60 * 1000;
export const CONTACT_US = "jobs@novelis.io";
export const server_uri = process.env.REACT_APP_GATEWAY_SERVER_API;
export const server_uri_api = process.env.REACT_APP_SERVER_API;
